import { feedSlice } from './slice';

export const { actions, reducer } = feedSlice;
export { selectors } from './adapter';
export * as thunks from './thunks';
export * from './types';
